import { useLocation } from 'react-router-dom';

export const useQueryParam = (key: string) => {
  const tmp = new URLSearchParams(useLocation().search);
  return tmp.get(key);
};
